






import { Vue, Component } from 'vue-property-decorator'
import Layout from '@/components/common/layout/Layout.vue'
import UserService from '@/services/UserService'
import LocaleHelper from '@/utils/LocaleHelper'
import { User } from '@/interfaces/UserInterfaces'

@Component({
  components: {
    appLayout: Layout
  }
})
export default class App extends Vue {
  isLoaded: boolean = false;

  async beforeCreate () {
    if (this.$auth.isAuthenticated()) {
      await UserService.getUser()
    }
  }

  async created () {
    if (this.$auth.isAuthenticated()) {
      try {
        const userData: User = await UserService.getUser()
        LocaleHelper.setUserLocale(userData.locale)
        this.isLoaded = true
      } catch (error) {
        if ('response' in error && error.response.status === 401) {
          await this.$auth.logout()
          await UserService.logout()
          this.isLoaded = true
          this.$router.push({ name: 'home' })
        } else {
          this.isLoaded = true
          throw error
        }
      }
    }
    const userLocale = LocaleHelper.getUserLocale()
    if (userLocale) {
      this.$i18n.locale = userLocale
      this.handleArabianLocale(userLocale)
      this.localizeValidator(LocaleHelper.getLocaleForVeeValidate(userLocale))
    }
    this.isLoaded = true
  }

  handleArabianLocale (userLocale: string): void {
    if (userLocale === 'ar') {
      document.getElementsByTagName('body')[0].classList.add('rtl')
    } else {
      document.getElementsByTagName('body')[0].classList.remove('rtl')
    }
  }
}
